<div class="avatar"
     [style.background-color]="props.background"
     [style.width]="props.size"
     [style.line-height]='props.lineheight'
     [style.height]='props.size'
     [style.font-size]='props.fontSize'
     [style.border-radius]='props.borderradius'>
  <span [style.color]='fontColor' class="avatar-letter">{{letter}}</span>
</div>
